import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { guidePropertiesSelector } from '../selectors/properties';
import { CHANGE_SELECTED_INDEX } from './types';

const guideChangeSelectedIndexActionPayloadSchema = Joi.object().keys({
  newIndex: Joi.number().required(),
});

export const guideChangeSelectedIndexAction = actionCreator(
  CHANGE_SELECTED_INDEX,
  guideChangeSelectedIndexActionPayloadSchema,
);

export const guideChangeSelectedIndexThunkAction = ({ newIndex }) => (dispatch, getState) => {
  const state = getState();
  let payload = { newIndex };

  const { list, selectedIndex } = guidePropertiesSelector(state);

  if (selectedIndex !== newIndex) {
    if (!list.some(({ index }) => index === newIndex)) {
      payload = new Error('Invalid index');
    }
    dispatch(guideChangeSelectedIndexAction(payload));
  }
};
